import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import MDIGITAL_ON_PREM from "./MDIGITAL_ON_PREM";

function loadForm(formId) {
  return KAMPYLE_ONSITE_SDK.loadForm(formId);
}

function showForm(formId, options) {
  return KAMPYLE_ONSITE_SDK.showForm(formId, options);
}

function closeForm(formId) {
  return KAMPYLE_ONSITE_SDK.closeForm(formId);
}

function createFormUrl(url, formId) {

  if (KAMPYLE_DATA.isV2Form(formId) && !!KAMPYLE_DATA.getData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.LIVE_FORM_V2_DEBUG_MODE)) {
    url = url.replace('/index.html','/debug/index.html');
  }

  url += '?formId=' + formId;
  url += '&type=live';
  url += '&isMobile=' + KAMPYLE_DATA.isMobile();

  // Because document.referrer doesnt allow seeing the #,
  // we need to send it to the iframe
  // TODO - send the site's url via message event
  var fullUrl = window.location.href;
  var splitted = fullUrl.split('?');
  if (splitted && splitted.length) {
    fullUrl = splitted[0];
  }
  url += '&referrer=' + encodeURIComponent(fullUrl);

  var region = KAMPYLE_DATA.getMemoryData('region');
  if (region) {
    url += '&region=' + region;
  }

  if (KAMPYLE_DATA.isFeatureEnabled('WCAG')) {
    url += '&isWCAG=true';
  }
  if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.CHTML_LOGS)){
      if(KAMPYLE_DATA.isCustomHtmlForm(formId)){
        url += '&chtmlLogs=true';
      }
    }

  url += '&displayType=' + KAMPYLE_DATA.getDisplayType(KAMPYLE_DATA.getFormData(formId)); // proviosn EMBEDDED_START

  if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.FORM_TEMPLATE_DATA_SEPERATION)){
    // In live-form controller provisions arrive after setExtraData event,
    // So in case of code conditioning by provision we have to pass it as a query parameter
    // TODO: Should remove once separateFormTemplateFromData provision is enabled for all
    url += '&isSeparateFormTemplateFromData=true';
  }
  
  url += '&domainsListRelativePath=' + encodeURIComponent(getDomainsListRelativePath(url));

  return url;
}

function getRelativePathByFoldersNum(numberOfFolders) {
  var domainListPath = '';
  for(var i = 0; i < numberOfFolders; i++) {
    // we use pipe instead of slash because of security
    // at some point it could not fetch a form when the path is too long with slashes
    domainListPath += '..|'
  }
  
  return domainListPath;
}

function getDomainsListRelativePath(url) {
  var region = getUrlPrefix().match(/((?:[\/](?!\/))[a-zA-Z0-9_-]+[\/a-zA-Z0-9_-]*)$/);  // can be /eu/ and such, or null
  var configurationPath = region ? region[0] + 'resources/config' : '/resources/config';

  if(KAMPYLE_DATA.getMemoryData('context') === 'preview') {
    return configurationPath;
  }
  
  var genericParsedUrl = KAMPYLE_UTILS.getParsedUrl(KAMPYLE_EMBED.getGenericLocation());
  var formParsedUrl = KAMPYLE_UTILS.getParsedUrl(url);
  
  if(genericParsedUrl.hostname !== formParsedUrl.hostname) {
    return configurationPath;
  } else {
    var genericFilePathname = genericParsedUrl.pathname;
    var formPathname = formParsedUrl.pathname;
    
    if(genericFilePathname && formPathname) {
      // remove env and file name from the path
      var genericPathnameParts = genericFilePathname.split('/').slice(1, -1);
      var formPathnameParts = formPathname.split('/').slice(1, -1);

      return getRelativePathByFoldersNum(formPathnameParts.length) + genericPathnameParts.join('/');
    }
    
    return '';
  }
}

function getFormFailureCause(formId) {
  var formState = KAMPYLE_DATA.getFormState(formId);
  var failureCause = null;

  for(var key in KAMPYLE_CONSTANT.FORM_LOADING_FAILURE_CAUSE){
    var failureCauseOption = KAMPYLE_CONSTANT.FORM_LOADING_FAILURE_CAUSE[key];
    if (formState[failureCauseOption] === true){
      failureCause = failureCauseOption;
      break;
    }
  }

  return failureCause;
}

function getUrlPrefix() {
  var isOnPrem = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ON_PREM_HYBRID);
  return isOnPrem ? MDIGITAL_ON_PREM.getPackageRoot() + "/" : KAMPYLE_CONSTANT.PLACEHOLDERS.URL_PREFIX;
}

function getSpinnerTemplate() {
  var spinnerHtml =  '<div id="' + KAMPYLE_CONSTANT.SPINNER_SETTINGS.CONTAINER_ID + '" class="neb-loading-spinner">';
  spinnerHtml += '<div id="' + KAMPYLE_CONSTANT.SPINNER_SETTINGS.ID+'"> </div>';  
  spinnerHtml += '</div>';
  return spinnerHtml;
}

export default {
  loadForm: loadForm,
  showForm: showForm,
  closeForm: closeForm,
  createFormUrl: createFormUrl,
  getSpinnerTemplate: getSpinnerTemplate,
  getUrlPrefix: getUrlPrefix,

  // For testing
  getFormFailureCause: getFormFailureCause,
  getDomainsListRelativePath: getDomainsListRelativePath
};
